import Link from "next/link";
import dynamic from "next/dynamic";
import CustomButton from "./CustomButton";
import ButtonTextIcon from "../_ui/ButtonTextIcon";
import { AnimatedSection, TextListFromNewline } from "../../utils/helpers";
import Image from "next/image";
import { SpecialTeam } from "../../data/surgicalAssistants";

const FormsForJobs = dynamic(() => import("../_pages/Jobs/FormsForJobs"));

// Re-use in all component except first component
export const SurgicalProcedure = () => {
  return (
    <section id="about-page">
      <section
        className="schedule-section"
        aria-label="Schedule a surgical procedure"
      >
        {/* background image */}
        <div
          className="schedule-bg"
          style={{ backgroundImage: "url(/images/schedule/landing.jpg)" }}
          aria-hidden="true"
        />

        {/* subtle foreground pattern (optional) */}
        {/* <div
        className="schedule-foreground"
        style={{ backgroundImage: "url(/images/about/foreground.webp)" }}
        aria-hidden="true"
      /> */}

        {/* bluish/dark overlay */}
        <div className="schedule-overlay" aria-hidden="true" />

        {/* content wrapper (uses container-p-14 from your globals) */}
        <div className="schedule-content container-p-14">
          <div className="schedule-inner">
            <h3 className="schedule-title">A Commitment to Surgical Excellence</h3>
            <p className="schedule-sub">Schedule A Surgical Procedure Today!</p>

            <Link href="/schedule-a-surgical" passHref>
              <CustomButton
                title="Schedule a Procedure"
                className="f-w-400"
                style={{
                  fontSize: "14px",
                  boxShadow: "0 8px 4px rgba(0, 0, 0, 0.3)",
                }}
              />
            </Link>
            {/*
          Fallback (if CustomButton ignores className):
          <Link href="/schedule-a-surgical" passHref>
            <a className="schedule-cta">Schedule a Surgical Procedure</a>
          </Link>
          */}
          </div>
        </div>
      </section>
    </section>
    // <section id="about-page">
    //   <div
    //     className="surgical-procedure pos-rel cover-img"
    //     style={{
    //       backgroundImage: `url(/images/schedule/landing.jpg)`,
    //     }}
    //   >
    //     <div className="container-p-14 ">
    //       <div
    //         className="flex b-r-5 center-center pos-rel cover-img"
    //         style={{
    //           backgroundImage: `url(/images/about/foreground.webp)`,
    //         }}
    //       >
    //         <div className="content ">
    //           <div className=" t-a-c">
    //             <h3
    //               className="font-mont f-w-600 color-blue"
    //               style={{
    //                 fontSize: "27.5px",
    //                 marginBottom: "13px",
    //               }}
    //             >
    //               A Commitment to Surgical Excellence
    //             </h3>
    //             <h5
    //               className="f-w-500"
    //               style={{
    //                 marginBottom: "11px",
    //               }}
    //             >
    //               Schedule A Surgical Procedure Today!
    //             </h5>
    //             <Link href="/schedule-a-surgical" passHref>
    //               <CustomButton
    //                 title="Schedule a Surgical Procedure"
    //                 className="f-w-400"
    //                 style={{
    //                   fontSize: "14px",
    //                   boxShadow: "0 8px 4px rgba(0, 0, 0, 0.2)",
    //                 }}
    //               />
    //             </Link>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </section>
  );
};

export const SpecialityIntro = ({ slope, link, introImg, title, introContentTop, introContentBottom }) => {
  const embedLink = link?.includes("youtube.com/watch") ? link.replace("watch?v=", "embed/") : link;

  return (
    <section id="speciality-page">
      <div className="intro pos-rel">
        {/* vector-design */}
        <div className="">
          {slope ? (
            <div className=" img block">
              {/* <img className="" src="/images/about/vector.png" alt="vector" /> */}
              <Image
                // className="b-r-10"
                src="/images/about/vector.png"
                alt="vector"
                width={500} // set your preferred width
                height={300} // set your preferred height
              />
            </div>
          ) : (
            ""
          )}
        </div>

        <div className="container  ">
          <div
            className=" flex  "
            style={{
              marginTop: "20px",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div className=" box flex center-center  ">
              {link ? (
                <div
                  className=""
                  style={{
                    width: "100%",
                    aspectRatio: "16 / 9",
                    maxWidth: "100%",
                  }}
                >
                  <iframe
                    style={{
                      width: "100%",
                      height: "100%",
                      border: "none",
                    }}
                    className="b-r-5"
                    src={embedLink}
                    title="Embedded Content"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
              ) : (
                <div className="flex center-center">
                  <div className="img ">
                    {/* <img className="b-r-10" src={introImg} alt={title} /> */}
                    <Image
                      className="b-r-10"
                      src={introImg}
                      alt={title}
                      width={500} // set your preferred width
                      height={300} // set your preferred height
                    />
                  </div>
                </div>
              )}

              <div className=" content flex center-center font-mont">
                <div
                  className=""
                  style={{
                    maxWidth: "650px",
                  }}
                >
                  <h4 className="font-barlow f-w-300 t-a-c t-t-u l-h-1 ">{title}</h4>
                  <br />
                  <div className=" t-a-c" style={{ maxWidth: "650px" }}>
                    <p className=" p-18 f-w-300">{introContentTop}</p>
                    <br />
                    <p className=" p-18 f-w-300">{introContentBottom}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export const SpecialityPerson = ({ personImg, common, pTitleTop, pTitleBot, contentTop, contentBot }) => {
  return (
    <section id="speciality-page">
      <div className="spe-person ">
        <div className="container">
          <div className="flex spe-box">
            <div className="flex">
              <AnimatedSection animation="bounceIn" delay="0s">
                <div className="img">
                  <img className="" src={personImg} alt={pTitleTop} />
                  {/* <Image
                      className="b-r-10"
                      src={personImg}
                      alt={pTitleTop}
                      width={500} // set your preferred width
                      height={300} // set your preferred height
                    /> */}
                </div>
              </AnimatedSection>
            </div>

            <div className="flex flex-1 center-left ">
              <div className=" spe-content">
                <h5 className="font-mont f-w-400">{common}</h5>
                <br />
                <h1 className="l-h-1 color-blue f-w-300 font-barlow">{pTitleTop}</h1>
                <h1 className="l-h-1 color-blue f-w-300 font-barlow">{pTitleBot}</h1>
                <br />
                <div className="font-nunito-sans l-h-1-5 p-18">
                  <p className="p-18 f-w-400">{contentTop}</p>
                  <br />
                  <p className="p-18">{contentBot}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export const SpecialitySurgicalTeam = ({ bg, title1, title2, content1, content2, iconTeam }) => {
  return (
    <section id="speciality-page">
      <div className="SpecialitySurgicalTeam">
        <section
          className="surgery-section"
          style={{
            backgroundImage: `url(${bg})`,
            backgroundPosition: "center center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          }}
        >
          <div className="overlay"></div>
          <div className="content">
            <h1>{title1}</h1>
            <p className="subtitle">{content1}</p>
            <article className="team-card">
              <div className="card-head">
                <img
                  className="b-r-5"
                  src={iconTeam}
                  alt={title2}
                  width="80"
                  height="80"
                />
                <div className="card-title">{title2}</div>
              </div>

              <div className="card-desc">{content2}</div>
            </article>
          </div>
        </section>
      </div>
    </section>
  );
};
export const SpecialityMD = ({ surgeonTxt1, surgeonTxt2, surgeonTxt3, surgeonTxt4, surgeonTxt5, surgeonIcon, surgeonImg }) => {
  return (
    <section id="service-page" className="speciality-page">
      <div
        className="service-support"
        style={{
          overflow: "hidden",
        }}
      >
        <div className="container">
          <div className="flex ssup-box">
            <div className="flex-1 flex center-center ssup-content ">
              <div className="card ">
                <div className="logo-section">
                  <img src={surgeonIcon} alt="Logo" />
                </div>
                <div className="info-section">
                  <h1 className="font-barlow">{surgeonTxt1}</h1>
                  <h2 className="font-barlow">{surgeonTxt2}</h2>
                  <p className="address font-barlow">{surgeonTxt3}</p>
                  <p className="specialty ">{surgeonTxt4}</p>
                  <a href="tel:7138429015" className="call-btn">
                    {surgeonTxt5}
                  </a>
                </div>
              </div>
            </div>

            <div className="flex-1 img img-box md-image">
              <AnimatedSection animation="slideInRight" speed="900ms">
                <img
                  className="b-r-5"
                  src={surgeonImg}
                  alt={surgeonTxt1}
                  width="500"
                  height="300"
                />
              </AnimatedSection>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export const SpecialityMDTeam = ({ surgeonTxt1, surgeonTxt2, surgeonTxt3, surgeonTxt4, surgeonTxt5, surgeonIcon, surgeonImg }) => {
  return (
    <section id="service-page" className="speciality-page">
      <div
        className="service-support"
        style={{
          overflow: "hidden",
        }}
      >
        <div className="container">
          <div className="md-team">
            {SpecialTeam.map((item, idx) => (
              <Link
                href={`/general-surgery-detailpage?slug=${item.surgeonTxt1}#surgeonD`}
                passHref
              >
                <div className="flex ssup-box">
                  <div className="flex center-center ssup-content ">
                    <div className="card ">
                      <div className="logo-section">
                        <img src={surgeonIcon} alt="Logo" />
                      </div>
                      <div className="info-section">
                        <h1 className="font-barlow">{item.surgeonTxt1}</h1>
                        <h2 className="font-barlow">{item.surgeonTxt2}</h2>
                        <p className="address font-barlow">{item.surgeonTxt3}</p>
                        <p className="specialty ">{item.surgeonTxt4}</p>
                        <a href="tel:7138429015" className="call-btn">
                          {item.surgeonTxt5}
                        </a>
                      </div>
                    </div>
                  </div>

                  <div className="img img-box md-image" style={{ width: "226px", height: "270px" }}>
                    {/* <AnimatedSection animation="slideInRight" speed="900ms" style={{ width: "226px", height: "270px" }}> */}
                    {/* <img
                className="b-r-5  "
                src="/images/services/s-support.webp"
                alt="service-support"
              /> */}
                    <Image
                      className="b-r-5"
                      src={item.surgeonImg}
                      alt="service-support"
                      width={500}
                      height={300}
                    />
                    {/* </AnimatedSection> */}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

// ==LISTING-ITEMS==
export const ListingItems = ({ link, data, icon, sliceStart, sliceEnd }) => {
  return (
    <div className=" flex-1 flex  listing-item">
      {data.slice(sliceStart, sliceEnd).map((d, index) => (
        <div
          className=" flex border-divider"
          key={index}
          style={{
            gap: "5px",
            // borderBottomStyle: "solid",
            // borderBottomWidth: "1px",
            // borderColor: "#DDDDDD",
            paddingTop: "5px",
            paddingBottom: "5px",
          }}
        >
          <div className=" flex center-center">
            {icon ? (
              <svg width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M13.7812 7C13.7812 10.7452 10.7452 13.7812 7 13.7812C3.25481 13.7812 0.21875 10.7452 0.21875 7C0.21875 3.25481 3.25481 0.21875 7 0.21875C10.7452 0.21875 13.7812 3.25481 13.7812 7ZM6.21562 10.5906L11.2469 5.55937C11.4177 5.38852 11.4177 5.1115 11.2469 4.94066L10.6282 4.32195C10.4573 4.15108 10.1803 4.15108 10.0094 4.32195L5.90625 8.4251L3.99057 6.50943C3.81973 6.33858 3.54271 6.33858 3.37184 6.50943L2.75313 7.12813C2.58229 7.29898 2.58229 7.576 2.75313 7.74684L5.59688 10.5906C5.76775 10.7615 6.04475 10.7615 6.21562 10.5906Z"
                  fill="white"
                />
              </svg>
            ) : (
              <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M4.75502 12.675L0.205017 8.12499C-0.0683389 7.85163 -0.0683389 7.40842 0.205017 7.13503L1.19494 6.14508C1.4683 5.8717 1.91154 5.8717 2.1849 6.14508L5.24999 9.21015L11.8151 2.64508C12.0884 2.37172 12.5317 2.37172 12.805 2.64508L13.795 3.63503C14.0683 3.90839 14.0683 4.3516 13.795 4.62499L5.74497 12.675C5.47159 12.9484 5.02837 12.9484 4.75502 12.675Z"
                  fill="#0B75B7"
                />
              </svg>
            )}
          </div>

          {d.link ? (
            <Link href={d.link} style={{ borderWidth: "0px" }} className="font-montserrat f-w-400 has-border-bottom custom-link">
              {d.item}
            </Link>
          ) : (
            <p className="font-montserrat f-w-400 has-border-bottom" style={{ borderWidth: "0px", color: "#54595F" }}>
              {d.item}
            </p>
          )}
        </div>
      ))}
    </div>
  );
};

// ==LISTING-ITEMS==
export const ListingItemsCareer = ({ link, data, icon, sliceStart, sliceEnd }) => {
  return (
    <ul className=" flex-1 flex  listing-item">
      {data?.slice(sliceStart, sliceEnd).map((d, index) => (
        <li className=" flex" key={index}>
          {d.link ? (
            <Link href={d.link} className="font-montserrat custom-link">
              {d.item}
            </Link>
          ) : (
            <p className="font-montserrat p-16 f-w-400">{d.item}</p>
          )}
        </li>
      ))}
    </ul>
  );
};

// == content-left & image-right with button(optional)
export const SurgicalAssistant = ({ image, title, content1, content2, content3, button = false }) => {
  return (
    <section id="internl-page">
      <div className="goal">
        <div className="container">
          <div className="flex row center-center">
            {/* outer-left */}

            <div className=" flex left-center flex-1 goal-content">
              <h2 className="l-h-1 p-60 color-blue f-w-300 font-barlow t-t-u">{title}</h2>
              <div className="font-nunito-sans  ">
                <p>{content1}</p>
                <br />
                <p>{content2}</p>
                <br />
                <p>{content3}</p>
              </div>

              {button && (
                <div className="btn">
                  <Link href="/careers">
                    <ButtonTextIcon
                      icon={
                        <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M11.8869 9.54111L10.1397 13.0356C9.92875 13.461 9.31703 13.447 9.12367 13.0146L7.12328 8.57432L6.06859 11.095H2.76039L9.1764 17.6517C9.42601 17.9083 9.83031 17.9083 10.0799 17.6517L16.4994 11.095H12.6639L11.8869 9.54111ZM17.2834 3.56807L17.1991 3.48018C15.3885 1.63096 12.4248 1.63096 10.6108 3.48018L9.62992 4.48564L8.64906 3.48369C6.83851 1.63096 3.87132 1.63096 2.06078 3.48369L1.9764 3.56807C0.264292 5.31885 0.190464 8.10674 1.71976 9.97002H5.31976L6.58187 6.93955C6.77171 6.48604 7.41156 6.47549 7.61546 6.92549L9.66156 11.4712L11.3842 8.02939C11.5916 7.61455 12.1823 7.61455 12.3897 8.02939L13.36 9.97002H17.5401C19.0694 8.10674 18.9955 5.31885 17.2834 3.56807Z"
                            fill="black"
                          />
                        </svg>
                      }
                      iconPosition="start"
                      title="JOIN OUR TEAM"
                    />
                  </Link>
                </div>
              )}
            </div>

            {/* outer-right */}
            <div className="image-box flex center-center">
              <div className=" img ">
                <AnimatedSection animation="bounceIn" delay="0.5s" speed="slow">
                  <img className="b-10" src={image} alt={title} />
                  {/* <Image
                      className="b-r-10"
                      src={image? image}
                      alt={title}
                      width={500} // set your preferred width
                      height={300} // set your preferred height
                    /> */}
                </AnimatedSection>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// ===== JOBS ====

export const CurrentAvailableJobs = ({ title, category, type, location, description, id, vacancy }) => {
  return (
    <section id="jobs">
      <div className="container">
        <div className="single-job-page ">
          <h2 className="t-t-u color-light-black">{title}</h2>
          <br />
          <div className="flex row">
            <div className="left font-nunito-sans ">
              <h5 className="font-nunito-sans f-w-400 color-black">Qualifications</h5>
              <div>
                <TextListFromNewline text={description} />
                <br />
              </div>
              <p>
                <span className="f-w-600">Job Category: </span> {category}
              </p>
              <p>
                <span className="f-w-600">Job Type:</span> {type}
              </p>
              <p>
                <span className="f-w-600">Job Location:</span> {location}
              </p>
              <p>
                <span className="f-w-600">Vacancy:</span> {vacancy}
              </p>
            </div>

            <div className="right flex-1 ">
              <FormsForJobs id={id} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// ==== LEFTCONTENT-RIGHTIMAGE ====
export const LeftContent_RightImage = ({ title, contentTop, contentBot, image, data }) => {
  return (
    <section id="home-page">
      <section
        className="care-support"
        style={{
          overflow: "hidden",
        }}
      >
        <div className="container">
          <div className="flex support-box">
            <div className="txt">
              <h5 className="f-w-300 font-barlow l-h-1-2 ">{title}</h5>
              <br />
              <p className="font-nunito-sans f-w-300 p-18">{contentTop}</p>
              <br />
              <p className="font-nunito-sans f-w-300 p-18">{contentBot}</p>
              <ListingItemsCareer data={data} />
            </div>

            <AnimatedSection animation="slideInRight" speed="700ms">
              <div
                className="flex-1 img"
                style={{
                  clipPath: " inset(0 0 0 0)",
                }}
              >
                <img
                  className="b-10"
                  src={image}
                  alt="support"
                  width="500"
                  height="300"
                />
              </div>
            </AnimatedSection>
          </div>
        </div>
      </section>
    </section>
  );
};
